/** @jsxImportSource @emotion/react */

const Image = ({ src, alt, ...rest }) => <img src={src} alt={alt} {...rest} />;

export default Image;
